import service from "../../Service/service";

const ClientCreateOrUpdate = async (payload) => {
    var data = {};
    try {
        await service.CreateOrUpdate("Client/CreateorUpdate", payload).then((res) => {
            if (res.data != undefined || res.data != null) {
                data = res.data;
            }
            else {
                data = "data not coming";
            }
        })
    } catch (error) {
        console.log(error);
        data = "someting went wrong";
    }
    return data;
}
const GetAllClient = async () => {
    var data = {};
    try {
        await service.GetAll("Client/GetAll").then((res) => {
            if (res.data != undefined || res.data != null) {
                data = res.data;
            }
            else {
                data = "data not coming";
            }
        })
    } catch (error) {
        console.log(error);
        data = "someting went wrong";
    }
    return data;
}

const GetClientById = async (id) => {
    var data = {};
    try {
        await service.GetById("Client/GetById?id=", id).then((res) => {
            if (res.data != undefined || res.data != null) {
                data = res.data;
            }
            else {
                data = "data not coming";
            }
        })
    } catch (error) {
        console.log(error);
        data = "someting went wrong";
    }
    return data;
}

export { ClientCreateOrUpdate, GetAllClient, GetClientById }